module.exports = __webpack_public_path__ + "static/img/home_11_2.7f8eed6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/homePage_new/home_11_2.png
// module id = 9aQH
// module chunks = 3 64